import getContractorFromDirectory from '@pages/AdditionalServices/components/ServiceDescription/getContractorFromDirectory';
import getDirectoryFieldsFromData from '@pages/AdditionalServices/containers/methods/basket/getDirectoryFieldsFromData';
import { getServiceFieldsByRows } from '@pages/AdditionalServices/containers/methods/basket/getServiceFieldsByRows';
import restoreServiceData from '@pages/AdditionalServices/containers/methods/basket/restoreServiceData';
import ServiceFieldsList from '@pages/Basket/components/ServicesList/components/OrderList/components/OrderListItem/components/ServiceBasketItem/ServiceFieldsList';
import ServicePropertyValue from '@pages/Basket/components/ServicesList/components/OrderList/components/OrderListItem/components/ServiceBasketItem/ServicePropertyValue';
import { HistoryServicesData } from '@pages/History/types';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getHistoryServicePath, makeHistoryServiceProduct } from './helpers';

/**
 * Пропсы компонента
 */
type ServiceHistoryItemProps = {
  services: HistoryServicesData;
  langId: string;
};

/**
 * Расчет доп. услуг из истории в том же виде, что в корзине
 */
export const ServiceHistoryItem = ({ services, langId }: ServiceHistoryItemProps) => {
  const { t } = useTranslation(['AdditionalService']);

  const product = useMemo(() => makeHistoryServiceProduct(services), [services]);
  const restoreResult = useMemo(() => restoreServiceData(product), [product]);

  if (!restoreResult) {
    return null;
  }

  const { setUpService, otherServices } = restoreResult;
  const isGroup = product.product_type === 'complex';

  const path = getHistoryServicePath(langId, setUpService);
  const directoryFields = getDirectoryFieldsFromData(setUpService);

  const fields = isGroup
    ? [...directoryFields, ...Object.values(getServiceFieldsByRows(setUpService, otherServices)).flat()]
    : [...setUpService.ServiceData.fields, ...directoryFields];

  const renderProperties = () => {
    if (isGroup) {
      const contractor = getContractorFromDirectory(
        langId,
        setUpService.Variant,
        setUpService.ServiceDataCache
      );

      return (
        <div className="property">
          <div className="name">
            <div className="description">
              {t('AdditionalService:ServiceDescriptionContractor')}:
            </div>
            <div>{contractor}</div>
          </div>
        </div>
      );
    }

    return Array.from([...Object.values(setUpService.ServicesPath), setUpService.Variant])
      .map((d) => d.properties)
      .flat(1)
      .filter((d, i, data) => data.map((d) => d.id).indexOf(d.id) === i)
      .filter((p) => !p.settings.Visuality.IsShowValueInDescription)
      .map((property) => (
        <ServicePropertyValue
          key={property.id}
          langID={langId}
          service={setUpService.ServiceData}
          property={property}
          propertyOptions={setUpService.PropertyOptions}
        />
      ));
  };

  return (
    <div className="a-service-basket">
      <div className={clsx('caption', { 'caption-empty': path.length === 0 })}>{path}</div>
      <div className="properties">{renderProperties()}</div>
      <ServiceFieldsList
        fields={fields}
        langID={langId}
        setUpService={setUpService}
        otherServices={isGroup ? otherServices : undefined}
      />
    </div>
  );
};
